import ServerTime from '../../../lib/server_time.js';
import localStore from 'store2';

const UNSENT = 'unsent';
const UNSENT_CHAT_IDS = 'unsentChatIds';

export default class UnsentMessagesManager {
  static chatsTracker = localStore.namespace('chats');

  static unsentChatIds = new Set();

  static addChatId(chatId) {
    this.unsentChatIds.add(chatId);
    this.chatsTracker.set(UNSENT_CHAT_IDS, Array.from(this.unsentChatIds));
  }

  static removeChatId(chatId) {
    this.unsentChatIds.delete(chatId);
    if (this.unsentChatIds.size === 0) {
      return this.chatsTracker.remove(UNSENT_CHAT_IDS);
    }

    this.chatsTracker.set(UNSENT_CHAT_IDS, Array.from(this.unsentChatIds));
  }

  static loadUnsentChatIds() {
    const chatIds = this.chatsTracker.get(UNSENT_CHAT_IDS);
    if (chatIds) this.unsentChatIds = new Set(chatIds);

    return this.unsentChatIds;
  }

  constructor({ translateFn, uploaders, chatId }) {
    this.t = translateFn;
    this.uploaders = uploaders;
    this.localStoreNamespace = `chat-${chatId}`;
    this.localStore = localStore.namespace(this.localStoreNamespace);
    this.chatId = chatId;
  }

  update(messages) {
    if (messages && messages.length) {
      this.localStore.set(UNSENT, messages);
      this.constructor.addChatId(this.chatId);
    } else {
      this.localStore.remove(UNSENT);
      this.constructor.removeChatId(this.chatId);
    }
  }

  get messages() {
    return this.prepare(this.rawMessages) || [];
  }

  get rawMessages() {
    return this.localStore.get(UNSENT);
  }

  /** @internal */
  processMessage(message) {
    Object.assign(message, {
      unsent: true,
      uploading: false,
      createdAt: ServerTime.toJSON(),
      errors: [this.t('errors.not_delivered')],
    });
  }

  /** @internal */
  prepare(messages) {
    if (!messages) return;

    messages.forEach(message => {
      if (this.uploaders.get(message.uuid)) return;

      this.processMessage(message);
    });

    return messages;
  }
}

UnsentMessagesManager.loadUnsentChatIds();
